import { Component, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastNotificationService } from '../core/toast-notification.service';
import { UIBlockingService } from '../core/ui-blocking.service';
import { DumbMemberDiscount } from '../public-portal/member-information/DTOs/dumb-member-discount';
import { AddEditChamberPerkModalComponent } from './add-edit-chamber-perk-modal.component';
import { SuperAdminMemberManagementService } from './super-admin-member-management.service';

@Component({
  selector: 'app-super-admin-chamber-perk-details',
  templateUrl: './super-admin-chamber-perk-details.component.html',
  providers: [UIBlockingService, NgbDropdown],
  encapsulation: ViewEncapsulation.None
})
export class SuperAdminChamberPerkDetailsComponent {
  constructor(private superAdminMemberManagementService: SuperAdminMemberManagementService
    , private route: ActivatedRoute
    , private blockUI: UIBlockingService
    , private notificationService: ToastNotificationService
    , private modalService: NgbModal) {

  }

  discountId: number;
  discount: DumbMemberDiscount = new DumbMemberDiscount();
  
  ngOnInit() {
    this.discountId = +this.route.snapshot.paramMap.get("discountId");

    this.getDiscountDetails();
  }
  getDiscountDetails() {
    this.blockUI.start();

    this.superAdminMemberManagementService
      .getDiscountDetails(this.discountId).subscribe(
        {
          next: (data) => {
            this.discount = data;
          },
          error: (err) => {
            this.notificationService.error(err.error.message);
            this.blockUI.stop();
            console.log(err)
          },
          complete: () => {
            this.blockUI.stop();
          }
        });
  }

  editPerk() {
    const modalRef = this.modalService.open(AddEditChamberPerkModalComponent, { size: 'lg', backdrop: 'static' });
    modalRef.componentInstance.admin = new DumbMemberDiscount();
    modalRef.componentInstance.headerText = "Edit Perk";
    modalRef.componentInstance.adding = false;
    modalRef.componentInstance.perk = this.discount;
    modalRef.result.then(response => {
      this.discount = response;
    })
      .catch(err => {

      }).finally();
  }

}
